module.exports = __webpack_public_path__ + "img/hat05_uv_umb.3d1b552e.svg";